// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__37Kmq","icon":"SortAdornment_icon__2xwBg","up":"SortAdornment_up__2xEob","down":"SortAdornment_down__2H-Xu","active":"SortAdornment_active__31GQm"};